// Helpers for working with the tag arrays returned by the MME API.
//
// A memory block from /memory/recent looks like:
//   {
//     id, content, ...,
//     tags: [{ label, type, confidence, ... }, ...],   // structured
//     tagsFlat: ["a", "a_b", "b", ...],                // pre-expanded strings
//   }
//
// `tagsFlat` is the richest source — the backend's tagcleaner already
// expanded compound tags into atomic forms ("taylor_swift" -> ["taylor",
// "swift", "taylor_swift"]) so display lists, search, and filters all
// see the same shape the retrieval layer sees. Use it when present.
//
// Older paths in this codebase tried `t.tag` and `t.name` keys — neither
// of those keys is on the current API. That mistake rendered every
// memory as "untagged" in the dashboard. The fallback below preserves
// `t.label` first; the older keys remain only for resilience against an
// older API server we might still encounter in dev.

export const tagsOf = (m) => {
  if (Array.isArray(m?.tagsFlat) && m.tagsFlat.length > 0) {
    return m.tagsFlat.filter(Boolean);
  }
  return (m?.tags || [])
    .map((t) => (typeof t === 'string' ? t : t?.label || t?.tag || t?.name || ''))
    .filter(Boolean);
};

export default tagsOf;
